import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

export const fetchSettings = createAsyncThunk('settings/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await api.get('/api/v1/settings').then(r => r.data)
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

export const saveSettings = createAsyncThunk('settings/save',
  async ({ section, data }, { rejectWithValue }) => {
    try {
      return await api.put(`/api/v1/settings/${section}`, data).then(r => r.data)
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    data:    null,   // full settings object from API
    loading: false,
    saving:  false,
    dirty:   {},     // { [section]: bool }
    error:   null,
  },
  reducers: {
    updateLocalSetting(state, { payload }) {
      const { section, key, value } = payload
      if (!state.data) state.data = {}
      if (!state.data[section]) state.data[section] = {}
      state.data[section][key] = value
      state.dirty[section] = true
    },
    clearDirty(state, { payload: section }) {
      state.dirty[section] = false
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchSettings.pending,  (s)    => { s.loading = true;  s.error = null })
    b.addCase(fetchSettings.rejected, (s, a) => { s.loading = false; s.error = a.payload })
    b.addCase(fetchSettings.fulfilled,(s, a) => { s.loading = false; s.data  = a.payload })

    b.addCase(saveSettings.pending,   (s)    => { s.saving = true })
    b.addCase(saveSettings.rejected,  (s, a) => { s.saving = false; s.error = a.payload })
    b.addCase(saveSettings.fulfilled, (s, a) => {
      s.saving = false
      // Merge saved section back into data
      if (s.data && a.payload.section) {
        s.data[a.payload.section] = a.payload.data
        s.dirty[a.payload.section] = false
      }
    })
  },
})

export const { updateLocalSetting, clearDirty } = settingsSlice.actions

export const selectSettings        = s => s.settings.data
export const selectSettingsLoading = s => s.settings.loading
export const selectSettingsSaving  = s => s.settings.saving
export const selectSettingsDirty   = s => s.settings.dirty
export const selectSettingsError   = s => s.settings.error

export default settingsSlice.reducer